import React, { useState, useEffect } from "react";
import { ReactSelectAdapter } from "../../reuseableComponents/forms/ReactSelectAdapter";
import { Row, Col } from "react-bootstrap";
import ButtonPill from "../../reuseableComponents/buttons/ButtonPill";
import ButtonSubmit from "../../reuseableComponents/buttons/ButtonSubmit";
import ButtonProcessing from "../../reuseableComponents/buttons/ButtonProcessing";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { Form, Field } from "react-final-form";
import {
  LOAD_USER_PROFILE_PAGE_DATA,
  GET_USER_SDWIS_REPORTS,
  ADD_SDWIS_REPORT,
  DELETE_SDWIS_REPORT
} from "../../../queries/archiveQrys/secureQrys/userProfileQrys";
import { useQuery, useMutation } from "@apollo/client";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";

const UserProfileSdwisReports = (umdId) => {
  const [sdwisReportsLoaded, setSdwisReportsLoaded] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [customSdwisReports, setCustomSdwisReports] = useState([]);
  const [sdwisReportsSelectList, setSdwisReportsSelectList] = useState([]);

  const updateSdwisReportsSelectList = (favoritesList, allSdwisReports) => {
    var result = allSdwisReports.filter(function (o1) {
      return !favoritesList.tables.some(function (o2) {
        return o1.reportId === o2.reportId;
      });
    });

    // Map the keys to react final form compatible
    const finalResult = result.map(({ reportId: value, reportName: label, ...rest }) => ({
      value,
      label,
      ...rest
    }));

    setSdwisReportsSelectList(finalResult);
  };

  const { loading, error, data } = useQuery(LOAD_USER_PROFILE_PAGE_DATA, {
    variables: umdId,
    onCompleted: (data) => {
      setCustomSdwisReports(data.getUserSdwisReportsByUmdId.tables);
      updateSdwisReportsSelectList(data.getUserSdwisReportsByUmdId, data.getAllSdwisTables);
      setSdwisReportsLoaded(true);
      setisLoading(false);
    }
  });

  const [addNewSdwisReportMutation, addResults] = useMutation(ADD_SDWIS_REPORT, {
    refetchQueries: [{ query: GET_USER_SDWIS_REPORTS, variables: umdId }],
    awaitRefetchQueries: true
  });

  const [deleteSdwisReportMutation, deleteResults] = useMutation(DELETE_SDWIS_REPORT, {
    refetchQueries: [{ query: GET_USER_SDWIS_REPORTS, variables: umdId }],
    awaitRefetchQueries: true
  });

  const onSubmit = (submit, form) => {
    let currentSdwisReports = data.getUserSdwisReportsByUmdId.tables;

    // Don't add report to the list if it already exists. To prevent duplicate keys.
    if (
      currentSdwisReports.some(function (o) {
        return o["reportId"] === submit.reportCode.value;
      })
    ) {
      alert("This report is already on your list.");
    } else {
      setisLoading(true);
      addNewSdwisReportMutation({
        variables: {
          umdId: umdId.umdId,
          reportId: submit.reportCode.value
        }
      });
    }

    form.reset();
  };

  const deleteReport = (reportId) => {
    setisLoading(true);
    deleteSdwisReportMutation({
      variables: {
        umdId: umdId.umdId,
        reportId: reportId
      }
    });
  };

  useEffect(() => {
    if (data && data.getUserSdwisReportsByUmdId !== undefined) {
      setCustomSdwisReports(data.getUserSdwisReportsByUmdId.tables);
    }
  }, [data, deleteResults, addResults, customSdwisReports]);

  function showReportButtons(defaultSdwisReports) {
    return !isLoading ? (
      <ButtonPill key={defaultSdwisReports.reportId} id='ddw-primary' label={defaultSdwisReports.reportName}>
        <FontAwesomeIcon
          className='font-icon'
          icon={faTimesCircle}
          onClick={() => deleteReport(defaultSdwisReports.reportId)}
        />
      </ButtonPill>
    ) : (
      <ButtonPill key={defaultSdwisReports.reportId} id='ddw-tertiary' label={defaultSdwisReports.reportName}>
        <FontAwesomeIcon className='font-icon' icon={faTimesCircle} />
      </ButtonPill>
    );
  }

  if (error) {
    return (
      <>
        <Row>
          <Col>
            <h3>SDWIS Selections</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <ErrorHandler error={error} />
          </Col>
        </Row>
      </>
    );
  }
  if (loading && !sdwisReportsLoaded) {
    return (
      <>
        <Row>
          <Col>
            <h3>SDWIS Selections</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <SkeletonLoader />
          </Col>
        </Row>
      </>
    );
  }
  return (
    <>
      <Row>
        <Col>
          <h3>SDWIS Selections</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form
            onSubmit={onSubmit}
            initialValues={{ umdId: umdId }}
            render={({ handleSubmit, form, submitting, values }) => (
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col>
                    <Field
                      name='reportCode'
                      component={ReactSelectAdapter}
                      options={sdwisReportsSelectList}
                      className='m-2'
                      placeholder='Select a Report ...'
                    />
                  </Col>
                  <Col>
                    {!isLoading ? (
                      <ButtonSubmit id='ddw-primary' label='Add Report' disabled={!values.reportCode}></ButtonSubmit>
                    ) : (
                      <ButtonProcessing id='ddw-primary' disabled />
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span className='error'>{addResults.error ? addResults.error.message : ""}</span>
                    <span className='error'>{deleteResults.error ? deleteResults.error.message : ""}</span>
                  </Col>
                </Row>
              </form>
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col>{customSdwisReports.map(showReportButtons, this)}</Col>
      </Row>
    </>
  );
};

export default UserProfileSdwisReports;
